import ApplicationController from './application_controller';

// Manages visibility of the SMS consent field based on phone number type selection.
// Works in two contexts:
//   1. Patient profile form — standard <select> with mobileIdValue
//   2. Intake document smart component — Impulse select with typeAutocomplete target
export default class extends ApplicationController {
  static targets = ['typeSelect', 'typeAutocomplete', 'smsField'];
  static values = { mobileId: String, intakeDocument: Boolean };

  connect() {
    this.updateVisibility();
  }

  // Called by the standard <select> change event on the patient profile form.
  typeSelectChanged() {
    this.updateVisibility();
  }

  // Called by awc-autocomplete:commit on the smart component type select. Its value is the type's name.
  onTypeSelected(event) {
    const typeName = event.detail?.value || '';
    this.setSmsVisible(typeName.toLowerCase() === 'mobile');
  }

  // Private

  updateVisibility() {
    if (this.hasTypeSelectTarget) {
      const typeId = this.typeSelectTarget.value;
      this.setSmsVisible(typeId === this.mobileIdValue);
    } else if (this.hasTypeAutocompleteTarget) {
      const typeName = (this.typeAutocompleteTarget.value || '').trim().toLowerCase();
      this.setSmsVisible(typeName === 'mobile');
    }
  }

  setSmsVisible(show) {
    if (this.hasSmsFieldTarget) {
      this.smsFieldTarget.classList.toggle('d-none', !show);
    }
  }
}
